module.exports = "<div class=\"container\">\n  <div class=\"row row-eq-height\">\n    <div class=\"col-md-6\">    \n      <app-station-map></app-station-map>\n    </div>\n    <div class=\"col-md-6\">    \n        <app-bike-usage></app-bike-usage>\n        <app-park-usage></app-park-usage>\n        <app-user-stat></app-user-stat>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main